import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-cycle */
import React, { useState, useEffect } from "react";
import { apiCompleteOrderForIntent, apiCreatePaymentIntent, apiApplePayShipping } from "Root/api/apiCheckout";
import toastService from "Root/profile/toastService";
import { PaymentRequestButtonElement, useStripe } from "@stripe/react-stripe-js";
import { convertPricingForStripe } from "Helpers/util";
import GainfulLoading from "Components/GainfulLoading";
import { useSelector } from "react-redux";
import { setOrderDataToLocalStorage } from "../CheckoutConfirmPayment/useCheckoutConfirmPayment";
const StripeExpressNew = (props) => {
    const stripe = useStripe();
    const [paymentRequest, setPaymentRequest] = useState(null);
    const [processing, setProcessing] = useState(false);
    const [options, setOptions] = useState(null);
    const isOtb = useSelector((state) => state.checkoutPricing.plan === "otb");
    const shippingData = useSelector((state) => state.checkoutShipping.address);
    const userEmail = useSelector((state) => state.user.email);
    const userCart = useSelector((state) => state.checkoutUserCart.userCart);
    const pricingData = useSelector((state) => state.checkoutPricing);
    async function recalc_apple_pay_address(event) {
        props.setShippingAddress(event.shippingAddress);
        try {
            const result = await apiApplePayShipping({
                shippingAddress: JSON.stringify(event.shippingAddress),
                otb: isOtb,
            });
            event.updateWith({
                status: "success",
                shippingOptions: result.supportedShippingOptions,
                displayItems: convertPricingForStripe(result.displayItems),
                total: {
                    label: "Total",
                    amount: Math.round(result.totalAmount),
                },
            });
        }
        catch (e) {
            toastService.errorMessage("Something went wrong");
        }
    }
    const completePayment = async (shippingAddressObj, shippingMethod, paymentIntentID) => {
        setProcessing(true);
        try {
            await apiCompleteOrderForIntent({
                shippingAddress: JSON.stringify(shippingAddressObj),
                shippingSpeed: shippingMethod,
                payment_intent_id: paymentIntentID,
                isStarterKit: false,
                otb: isOtb,
            });
            toastService.successMessage(`Order successfully placed!`);
            if (isOtb) {
                const shippingObj = typeof shippingAddressObj === "string" ? JSON.parse(shippingAddressObj) : shippingAddressObj;
                setOrderDataToLocalStorage({
                    shippingAddress: {
                        street: Array.isArray(shippingObj.addressLine)
                            ? shippingObj.addressLine[0]
                            : shippingObj.addressLine,
                        apartment: Array.isArray(shippingObj.addressLine) && shippingObj.addressLine.length > 1
                            ? shippingObj.addressLine[1]
                            : "",
                        city: shippingObj.city,
                        state: shippingObj.region || shippingObj.state,
                        zip: shippingObj.zip,
                        country: shippingObj.country,
                        firstName: shippingObj.recipient ? shippingObj.recipient.split(" ")[0] : shippingObj.firstName,
                        lastName: shippingObj.recipient && shippingObj.recipient.split(" ").length > 1
                            ? shippingObj.recipient.split(" ")[1]
                            : shippingObj.lastName,
                    },
                    pricing: pricingData.otb,
                    items: userCart,
                    email: userEmail,
                });
                if (isOtb) {
                    window.location.href = "/logout?next=/shop/thank-you/";
                }
                else {
                    window.location.href = "/app/thank-you/";
                }
                return;
            }
            window.location.href = "/app/thank-you/";
        }
        catch (err) {
            toastService.errorMessage("Something went wrong");
        }
    };
    useEffect(() => {
        setOptions(null);
        if (stripe) {
            const pr = stripe.paymentRequest({
                country: "US",
                currency: "usd",
                total: {
                    label: "Total",
                    amount: Math.round(props.totalAmount),
                },
                requestPayerName: true,
                requestPayerEmail: props.isGuest,
                shippingOptions: props.shippingOptions,
                requestShipping: true,
                displayItems: props.stripeDisplayItems,
            });
            // Check the availability of the Payment Request API.
            pr.canMakePayment().then((result) => {
                if (result) {
                    setPaymentRequest(pr);
                    pr.on("shippingaddresschange", (event) => {
                        const { shippingAddress } = event;
                        if (shippingAddress.country !== "US" && shippingAddress.country !== "CA") {
                            event.updateWith({ status: "invalid_shipping_address" });
                        }
                        else {
                            recalc_apple_pay_address(event);
                        }
                    });
                    pr.on("paymentmethod", async (ev) => {
                        // @ts-ignore
                        const data = {};
                        const shipping = JSON.stringify(ev.shippingAddress);
                        // Notify users if ApplePay doesn't return an address
                        if (shipping === "null") {
                            ev.complete("fail");
                            toastService.errorMessage("We did not receive a shipping address, please try again.");
                            return;
                        }
                        if (ev.payerEmail) {
                            // @ts-ignore
                            data.payerEmail = ev.payerEmail;
                        }
                        data.shippingAddress = shipping;
                        data.shippingSpeed = ev.shippingOption.id;
                        data.paymentMethod = ev.methodName;
                        data.payment_method_id = ev.paymentMethod.id;
                        data.isStarterKit = false;
                        data.otb = isOtb;
                        const resp = await apiCreatePaymentIntent(data);
                        // Confirm the PaymentIntent without handling potential next actions (yet).
                        const { paymentIntent, error: confirmError } = await stripe.confirmCardPayment(resp.clientSecret, { payment_method: ev.paymentMethod.id }, { handleActions: false });
                        if (confirmError) {
                            // Report to the browser that the payment failed, prompting it to
                            // re-show the payment interface, or show an error message and close
                            // the payment interface.
                            ev.complete("fail");
                        }
                        else {
                            // Report to the browser that the confirmation was successful, prompting
                            // it to close the browser payment method collection interface.
                            ev.complete("success");
                            console.log(data);
                            // Check if the PaymentIntent requires any actions and if so let Stripe.js
                            // handle the flow. If using an API version older than "2019-02-11"
                            // instead check for: `paymentIntent.status === "requires_source_action"`.
                            if (paymentIntent.status === "requires_action") {
                                // Let Stripe.js handle the rest of the payment flow.
                                const { error } = await stripe.confirmCardPayment(resp.clientSecret);
                                if (error) {
                                    // The payment failed -- ask your customer for a new payment method.
                                    toastService.errorMessage("Your payment failed.");
                                }
                                else {
                                    // The payment has succeeded.
                                    completePayment(data.shippingAddress, data.shippingSpeed, paymentIntent.id);
                                }
                            }
                            else {
                                // The payment has succeeded.
                                completePayment(data.shippingAddress, data.shippingSpeed, paymentIntent.id);
                            }
                        }
                    });
                    setOptions({
                        paymentRequest: pr,
                        style: {
                            paymentRequestButton: {
                                height: "55px",
                            },
                        },
                    });
                }
            });
        }
    }, [props.totalAmount]);
    if (options) {
        return (_jsxs(_Fragment, { children: [processing && _jsx(GainfulLoading, {}), _jsx(PaymentRequestButtonElement, { options: options })] }));
    }
    // Use a traditional checkout form.
    return null;
};
export default StripeExpressNew;
